module.exports = __webpack_public_path__ + "cf50ea8d2522bdb0da45dd187ba647b1.png";